import React, { useMemo } from 'react'
import { createRoot } from 'react-dom/client'
import { useWagmi } from 'libs/wagmi'
import { BLOCKED_ADDRESSES } from './config/constants'
import ListsUpdater from './state/lists/updater'
import MulticallUpdater from './state/multicall/updater'
import TransactionUpdater from './state/transactions/updater'
import App from './App'
import Providers from './Providers'

const container = document.getElementById('root')
const root = createRoot(container)

function BlockList({ children }) {
  const { account } = useWagmi()
  const blocked: boolean = useMemo(() => Boolean(account && BLOCKED_ADDRESSES.indexOf(account) !== -1), [account])

  if (blocked) {
    return <div>Blocked address</div>
  }

  return children
}

root.render(
  <React.StrictMode>
    <Providers>
      <BlockList>
        <ListsUpdater />
        <TransactionUpdater />
        <MulticallUpdater />
        <App />
      </BlockList>
    </Providers>
  </React.StrictMode>,
)
